/**
 * HarvestInspectionsExportAllMergedDropdownItem
 */
import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { requestExportReportsHarvestInspectionsAllMerged } from '../../../../../../../../services/reportsHarvestInspectionsAllMerged/actions';

interface Props {
    requestExportReportsHarvestInspectionsAllMerged: Function;
}

export class HarvestInspectionsExportAllMergedDropdownItem extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.requestExportReportsHarvestInspectionsAllMerged();
    };

    render() {
        return (
            <Dropdown.Item
                text="Harvest Quality Detailed"
                onClick={this.handleClick}
            />
        );
    }
}

export default connect(
    null,
    { requestExportReportsHarvestInspectionsAllMerged }
)(HarvestInspectionsExportAllMergedDropdownItem);
